import { httpsCallable } from 'firebase/functions';
import { functions } from '../model/instances';

export const reportClass = httpsCallable(functions, 'reportClass');
